import angular from 'angular';
import SelectUserBridge from './SelectUserBridge';

angular
  .module('flowingly.components')
  .component('selectUserReact', SelectUserBridge);
